import { Component } from '@angular/core';
import { Store } from "@ngrx/store";
import { currentActionPanelView } from "@store/doc-viewer/action-panel/action-panel.selectors";
import { ActionPanelViews } from "@store/doc-viewer/doc-viewer.state";
import { actionPanelActions } from "@store/doc-viewer/action-panel/action-panel.actions";
import { DocViewerParamReader } from '@utilities/doc-viewer-param-reader';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { distinctUntilChanged, takeUntil } from 'rxjs';
import { BaseComponent } from '../../base.component';

@Component({
    selector: 'lex-doc-viewer-bottom-right-bar',
    templateUrl: './doc-viewer-bottom-right-bar.component.html',
    styleUrls: ['./doc-viewer-bottom-right-bar.component.scss'],
    standalone: false
})
export class DocViewerBottomRightBarComponent extends BaseComponent {
	public menuPanelViews = ["compare-doc", "split-document", "facts-and-issues", "translate", "download", "hits"];
	public currentActionPanelView$ = this.store.select(currentActionPanelView());
	public hasHits = false;

	constructor(
		private store: Store,
		private paramReader: DocViewerParamReader,
		private docViewerStore: DocViewerStore) {
		super();

		docViewerStore.currentDocument$.pipe(
			distinctUntilChanged((prevDoc, currentDoc) =>
				prevDoc.docId === currentDoc.docId
			),
			takeUntil(this.destroy$)
		).subscribe(() => {
			this.hasHits = this.paramReader.fromSearch;
		});

	}

	public updateActionPanelView(selectedView: ActionPanelViews) {
		this.store.dispatch(actionPanelActions.viewUpdated({selectedView}));
	}

}
